import { clsx } from '../../utils/cn.js';

export default function FormField({ label, error, children, hint, variant = 'dark', required, size = 'default' }) {
  const light = variant === 'light';
  const large = size === 'lg';

  return (
    <label className="block space-y-1.5">
      <span
        className={clsx(
          'font-semibold uppercase tracking-wide',
          large ? 'text-sm' : 'text-xs',
          light ? 'text-slate-600' : 'text-slate-400'
        )}
      >
        {label}
        {required ? <span className="text-red-500"> *</span> : null}
      </span>
      {children}
      {hint && (
        <p className={clsx(large ? 'text-sm' : 'text-xs', light ? 'text-slate-500' : 'text-slate-500')}>{hint}</p>
      )}
      {error && (
        <p className={clsx(large ? 'text-sm' : 'text-xs', light ? 'text-red-600' : 'text-red-400')}>{error}</p>
      )}
    </label>
  );
}
